import { action } from 'mobx';
import { Record, RecordStore } from '../records/RecordStore';

export class Filter extends Record {
  constructor(id, rootStore, collectionName) {
    super(id, rootStore);
    this.collectionName = collectionName;
    this.get();
  }

  @action.bound
  getFees() {}

  @action.bound
  getLinks() {}

  @action.bound
  getNotes() {}
}

export class FilterStore extends RecordStore {
  constructor(rootStore) {
    super(rootStore);
    this.collectionName = 'filters';
  }

  @action
  get(id) {
    this.record = new Filter(id, this.rootStore, this.collectionName);
  }
}
